import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import { prevButton, nextButton, iconStyles } from '../styles/testimonials.styles';

function CarouselNavigation({ onPrev, onNext }) {
  return (
    <>
      <Button
        id="prev-button"
        onClick={onPrev}
        disableRipple
        sx={prevButton}
      >
        <ArrowBackIosRoundedIcon sx={iconStyles} />
      </Button>
      <Button
        id="next-button"
        onClick={onNext}
        disableRipple
        sx={nextButton}
      >
        <ArrowForwardIosRoundedIcon sx={iconStyles} />
      </Button>
    </>
  );
}

CarouselNavigation.propTypes = {
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

export default CarouselNavigation;
